import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCustomerStatus } from 'services/CustomerService'

export const useCustomerStatusQuery = (onboardingId: string) => {
  return useQuery({
    queryKey: reactQueryKeys.customerStatus(onboardingId),
    queryFn: () => getCustomerStatus(onboardingId),
    enabled: !!onboardingId,
  })
}
